import React, { useEffect } from "react";
import Modal from 'olive-react-myoneui/lib/Modal';
import Button from 'olive-react-myoneui/lib/Button';
import messageLogo from '../../assets/images/logo-message.svg';
import { useSelector } from 'react-redux';

function ThankYouModal(props) {
  const setHidden = () => {
    props.onHide();
  }
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="thankyou-modal"
      backdropClassName='backdrop-thankyou'
    >
      <div className="course-reminder-content">
        <Modal.Body>
          <div className="">
            <span><img src={'front_end/' + messageLogo} className="img-fluid icon-modal"/></span>
            <h1 className="heading-modal">{props.successTitle}</h1>
            <p className="desc-modal" dangerouslySetInnerHTML={{__html: props.successMessage}}></p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="px-4" onClick={setHidden}>OK</Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default ThankYouModal;